import TriviaGame9 from '@containers/IQOSUniverse/articles/TriviaGame9/TriviaGame9';

export default TriviaGame9;